<template src="./NavBar.html"></template>
<style lang="scss" src="./Navbar.scss"></style>
<script>
export default {
  name: "NavBar",
  props: {
    isMobileSidebarOpen: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoggedIn: false,
    };
  },
  async mounted() {
    this.isLoggedIn = localStorage.getItem("user_id") !== null;
  },
  methods: {
    toggleMobileSidebar() {
      const newState = !this.isMobileSidebarOpen;
      this.$emit("toggle-sidebar", newState);
    },
    handleSignOut() {
      localStorage.clear();
      this.$router.go("/");
    },
    search() {},
    getUserInitials() {
      return (
        localStorage.getItem("first_name")?.charAt(0).toUpperCase() +
        localStorage.getItem("last_name")?.charAt(0).toUpperCase()
      );
    },
    goToHome() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>
